export default __webpack_public_path__ + "e8620fca0bc796aa8a0abe37c4a7d4f7.jpg";